import { useEffect, useState } from 'react';

interface Props {
  startAt?: string;
  lastUpdated?: string;
}

type Duration = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

export const msToDuration = (ms: number): Duration => {
  let delta = ms;
  const days = Math.floor(delta / (24 * 60 * 60 * 1000));
  delta -= days * 24 * 60 * 60 * 1000;
  const hours = Math.floor(delta / (60 * 60 * 1000));
  delta -= hours * 60 * 60 * 1000;
  const minutes = Math.floor(delta / (60 * 1000));
  delta -= minutes * 60 * 1000;
  const seconds = Math.floor(delta / 1000);
  return { days, hours, minutes, seconds };
};

export const LiveDuration = ({ startAt, lastUpdated }: Props) => {
  const startMs = startAt ? new Date(startAt).getTime() : 0;
  const lastMs = lastUpdated ? new Date(lastUpdated).getTime() : Date.now();
  const baseMs = Math.max(lastMs - startMs, 0);

  const [duration, setDuration] = useState<Duration>(() =>
    msToDuration(baseMs)
  );

  useEffect(() => {
    if (!startAt) return;
    const start = new Date(startAt).getTime();
    const last = lastUpdated ? new Date(lastUpdated).getTime() : Date.now();
    const base = Math.max(last - start, 0);

    const tick = () => {
      const now = Date.now();
      const total = base + (now - last);
      setDuration(msToDuration(total));
    };

    const id = setInterval(tick, 1000);
    tick();
    return () => clearInterval(id);
  }, [startAt, lastUpdated]);

  return (
    <div>
      <div className="fw-bold">Tiempo total</div>
      <div>
        {duration.days}d {duration.hours}h {duration.minutes}m{' '}
        {duration.seconds}s
      </div>
    </div>
  );
};

export default LiveDuration;
